import { render, staticRenderFns } from "./LDataTable.vue?vue&type=template&id=d4ea5482&scoped=true"
import script from "./LDataTable.vue?vue&type=script&lang=js"
export * from "./LDataTable.vue?vue&type=script&lang=js"
import style0 from "./LDataTable.vue?vue&type=style&index=0&id=d4ea5482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ea5482",
  null
  
)

export default component.exports